import { memo } from "react"

type SvgProps = React.ComponentPropsWithoutRef<"svg">

/**
 * 時計回りに 90° 回転するアイコン (RotateCcwIcon を水平反転したもの)。
 */
export const RotateCwIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
      <path d="M21 3v5h-5" />
    </svg>
  )
})

RotateCwIcon.displayName = "RotateCwIcon"
